export default __webpack_public_path__ + "static/media/firefox.5a7f8a93.png";